import { userRoutes } from 'modules/user/routes/constants';

export const userSignUpRoutes = {
  root: `${userRoutes.root}/signup`,
};
